import axios from "../plugins/parseAxios";
export class CompanionAPI {
  constructor(props) { }
  static getCompanions(payload) {
    return axios.post("functions/getCompanions", {
      projectId: payload.projectId,
    });
  }
  static getCompanion(payload) {
    return axios.post("functions/getCompanion", {
      id: payload.id,
    });
  }
  static createCompanion(payload) {
    return axios.post("functions/createCompanion", payload);
  }
  static updateCompanion(payload) {
    return axios.post("functions/updateCompanion", payload);
  }
  static getCompanionByKeyword(payload) {
    return axios.post("functions/getCompanionByKeyword", payload)
  }
  static getCompanionsByCustomer(payload) {
    return axios.post("functions/getCompanionsByCustomer", payload)
  }
  static getCompanionsByProject(projectId, limit, page, order) {
    return axios.post("functions/getCompanionsByProject", {
      projectId,
      limit,
      page,
      order,
    });
  }
  static getCompanionsLengthByProject(projectId) {
    return axios.post("functions/getCompanionsLengthByProject", { projectId })
  }
}
